import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { getContent } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import WhiteContainer from '../../../components/Container/WhiteContainer';
import ActionType from '../../../redux/reducer/globalActionType';
import MasterDataAuditDetail from '../../../components/MasterData/MasterDataAuditDetail';
import MasterDataDataGroupButton from '../../../components/MasterData/MasterDataDataGroupButton';
import DataScopeDetail from '../DataScope/Detail';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_DATA_GROUP_VIEW } from '../../../constants/menuPermissionConstant';

class DataGroupDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataGroupDetail: {},
            createdAt: '',
            updatedAt: '',
            dataScopePage: false
        }
    }

    getDetailDataGroup = () => {
        API_MASTER_DATA.getDetailDataGroup(this.props.match.params.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        dataGroupDetail: getContent(res),
                        createdAt: moment.utc(getContent(res).created_at).format('DD MMMM YYYY HH:mm'),
                        updatedAt: moment.utc(getContent(res).updated_at).format('DD MMMM YYYY HH:mm'),
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleDataGroup = () => {
        this.setState({
            dataScopePage: false
        })
    }

    handleDataScope = () => {
        this.setState({
            dataScopePage: true
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getDetailDataGroup();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_GROUP_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="data-group-container">
                    {
                        this.state.dataScopePage
                            ? <DataScopeDetail
                                data={this.state.dataGroupDetail}
                                dataScopePage={this.state.dataScopePage}
                                handleDataGroup={this.handleDataGroup}
                                handleDataScope={this.handleDataScope}
                            />
                            : <div className="data-group-detail">
                                <MasterDataDataGroupButton
                                    dataScopePage={this.state.dataScopePage}
                                    handleDataGroup={this.handleDataGroup}
                                    handleDataScope={this.handleDataScope}
                                />
                                <WhiteContainer>
                                    <div className="flex">
                                        <div className="w-1/2 p-10 kiri">
                                            <div className="flex justify-between w-full mb-5">
                                                <div className="w-1/6 pr-5 text-right">
                                                    <label className="select-none font-medium text-gray-400" htmlFor="tsldatagroupid">Group ID</label>
                                                </div>
                                                <div className="w-5/6">
                                                    <input
                                                        type="text"
                                                        id="tsldatagroupid"
                                                        name="dataGroupId"
                                                        className="form-control"
                                                        defaultValue={this.state.dataGroupDetail.group_id}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex justify-between w-full mb-5">
                                                <div className="w-1/6 pr-5 text-right">
                                                    <label className="select-none font-medium text-gray-400" htmlFor="tmldatagroupdescription">Deskripsi</label>
                                                </div>
                                                <div className="w-5/6">
                                                    <textarea
                                                        id="tmldatagroupdescription"
                                                        name="dataGroupDescription"
                                                        className="form-control resize-none h-48 2xl:h-40"
                                                        defaultValue={this.state.dataGroupDetail.description}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <MasterDataAuditDetail
                                            createdAt={this.state.createdAt}
                                            updatedAt={this.state.updatedAt}
                                            modifiedBy={this.state.dataGroupDetail.modified_by}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        id="btnclose"
                                        className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2 absolute bottom-5 right-5"
                                        onClick={() => this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP)}
                                    >
                                        Tutup
                                    </button>
                                </WhiteContainer>
                            </div>
                    }
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataGroupDetail));